import { useRef, useState, useEffect } from "react";
import emailjs from "emailjs-com";

export default function Form() {
  const form = useRef();
  const [isSent, setIsSent] = useState(false);
  const [error, setError] = useState(null);

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .sendForm(
        "service_uh0papo",
        "template_myrpl6k",
        form.current,
        "2pcpdniY8ZZ0tl3CK"
      )
      .then(
        (result) => {
          console.log("Email sent:", result.text);
          setIsSent(true);
          setError(null);
          form.current.reset();
        },
        (error) => {
          console.error("Error sending email:", error.text);
          setError("Something went wrong. Please try again later.");
          setIsSent(false);
        }
      );
  };

  useEffect(() => {
    let timer;
    if (isSent || error) {
      timer = setTimeout(() => {
        setIsSent(false);
        setError(null);
      }, 5000); // Remove message after 5 seconds
    }
    return () => clearTimeout(timer);
  }, [isSent, error]);

  return (
    <div className="contact-form flex">
      <h2 className="fs-700 clr-white medium">Send us a message</h2>
      <p className="clr-gray-text">
        Reach out to us for any inquiries or support. We're here to assist
        you—connect via email and phone.
      </p>

      <form ref={form} onSubmit={sendEmail}>
        <div className="inputs-holder ">
          <div className="contact-input-container flex">
            <label className="clr-white medium" htmlFor="name">
              Name*
            </label>
            <input
              className="clr-gray"
              type="text"
              name="name"
              id="name"
              placeholder="Name"
              required
            />
          </div>
          <div className="contact-input-container flex">
            <label className="clr-white medium" htmlFor="surname">
              Surname*
            </label>
            <input
              className="clr-gray"
              type="text"
              name="surname"
              id="surname"
              placeholder="Surname"
              required
            />
          </div>
        </div>
        <div className="inputs-holder">
          <div className="contact-input-container flex">
            <label className="clr-white medium" htmlFor="phone">
              Phone*
            </label>
            <input
              className="clr-gray"
              type="number"
              name="phone"
              id="phone"
              placeholder="Phone"
              required
            />
          </div>
          <div className="contact-input-container flex">
            <label className="clr-white medium" htmlFor="email">
              Email*
            </label>
            <input
              className="clr-gray"
              type="email"
              name="email"
              id="email"
              placeholder="Email"
              required
            />
          </div>
        </div>
        <div className="contact-input-container flex">
          <label className="clr-white medium" htmlFor="subject">
            Subject*
          </label>
          <input
            className="clr-gray"
            type="text"
            name="subject"
            id="subject"
            placeholder="Subject"
            required
          />
        </div>
        <div className="contact-input-container flex">
          <label className="clr-white medium" htmlFor="message">
            Message*
          </label>
          <textarea
            name="message"
            id="message"
            placeholder="Message"
            required
          ></textarea>
        </div>
        <input
          className="greenblue-button fs-200 clr-dark transition pointer"
          type="submit"
          value="Send message"
        />
        {isSent && (
          <div className="message success-message">
            <i className="icon-check-circle"></i>
            <p>Your message was sent successfully!</p>
          </div>
        )}
        {error && (
          <div className="message error-message">
            <i className="icon-error"></i>
            <p>{error}</p>
          </div>
        )}
      </form>

      <style jsx>{`
        .message {
          display: flex;
          align-items: center;
          padding: 10px;
          margin-top: 10px;
          border-radius: 5px;
          animation: fadeIn 0.5s ease-in-out;
        }
        .success-message {
          background-color: rgba(76, 175, 80, 0.1);
          color: #4caf50;
        }
        .error-message {
          background-color: rgba(244, 67, 54, 0.1);
          color: #f44336;
          animation: shake 0.5s;
        }
        .icon-check-circle {
          margin-right: 10px;
          color: #4caf50;
        }
        .icon-error {
          margin-right: 10px;
          color: #f44336;
        }
        @keyframes fadeIn {
          from {
            opacity: 0;
          }
          to {
            opacity: 1;
          }
        }
        @keyframes shake {
          0%,
          100% {
            transform: translateX(0);
          }
          20%,
          60% {
            transform: translateX(-10px);
          }
          40%,
          80% {
            transform: translateX(10px);
          }
        }
      `}</style>
    </div>
  );
}
